import {createI18n} from "vue-i18n";
import en from "../locales/en.json";
import cs_cz from "../locales/cs_cz.json";
import da_dk from "../locales/da_dk.json";
import de_at from "../locales/de_at.json";
import de_de from "../locales/de_de.json";
import de_ch from "../locales/de_ch.json";
import en_ie from "../locales/en_ie.json";
import es_es from "../locales/es_es.json";
import fi_fi from "../locales/fi_fi.json";
import fr_be from "../locales/fr_be.json";
import fr_fr from "../locales/fr_fr.json";
import it_it from "../locales/it_it.json";
import fr_lu from "../locales/fr_lu.json";
import nl_nl from "../locales/nl_nl.json";
import no_no from "../locales/no_no.json";
import pt_pt from "../locales/pt_pt.json";
import sk_sk from "../locales/sk_sk.json";
import sv_se from "../locales/sv_se.json";
// 这里导入其他语言包

// 语言包
const messages = {
    en,
    cs_cz,
    da_dk,
    de_at,
    de_de,
    de_ch,
    en_ie,
    es_es,
    fi_fi,
    fr_be,
    fr_fr,
    it_it,
    fr_lu,
    nl_nl,
    no_no,
    pt_pt,
    sk_sk,
    sv_se,
};

const getLanguageByStory = () => {
    const value = sessionStorage.getItem("globalLanguage")
    if (value) return value
    return 'en'
}

export const i18n = createI18n({
    legacy: false,
    locale: getLanguageByStory(),
    fallbackLocale: getLanguageByStory(),
    messages,
    // 添加missing handler来处理缺失的翻译
    missingWarn: false,
    fallbackWarn: false
});

// 自定义翻译函数，当没有翻译时返回空字符串
export const customT = (key, locale = null) => {
    const currentLocale = locale || i18n.global.locale.value;
    const message = messages[currentLocale];
    
    // 检查当前语言包中是否存在该key
    if (message && message[key]) {
        return message[key];
    }
    
    // 如果当前语言包中没有，且不是fallback语言，检查fallback语言
    const fallbackLocale = i18n.global.fallbackLocale.value;
    if (currentLocale !== fallbackLocale && messages[fallbackLocale] && messages[fallbackLocale][key]) {
        return messages[fallbackLocale][key];
    }
    
    // 如果都没有找到，返回空字符串而不是key
    return '';
};

export const globalT = customT; // 使用自定义翻译函数
export const globalLocale = i18n.global.locale;

export function setLanguage(lang) {
    // if (lang === 'en' || lang === 'zh') {
        globalLocale.value = lang;
        sessionStorage.setItem('globalLanguage', lang)
    // }
}

// 创建自定义指令
export const vT = {
    mounted(el, binding) {
        el.textContent = customT(binding.value);
    },
    updated(el, binding) {
        el.textContent = customT(binding.value);
    }
};

export function registerDirectives(app) {
    app.directive('t', vT);
}
